import {putResolve, takeLeading, select, takeEvery} from 'redux-saga/effects';
import {
	LOGIN_ANONYMOUS,
	LOGIN_ANONYMOUS_FAILURE,
	LOGIN_ANONYMOUS_REQUEST,
	LOGIN_ANONYMOUS_SUCCESS,
	RESIGNUP,
	RESIGNUP_FAILURE,
	RESIGNUP_REQUEST,
	RESIGNUP_SUCCESS,
} from 'new-constants/api.constants';
import {loginAnonymous, resignup} from 'new-actions/api.actions.ts';
import {getStartupParams} from 'helpers/startup-params.helper';
import {getCalculatedGlobalShortLocale} from 'helpers/localization.helper.ts';
import {getCurrentAppIdSelector, getCurrentAuthSelector, getCurrentServerConfig} from "../selectors";
import {CUSTOMER_FAILURE} from "../constants/api.constants";

function isAuthNotFetched(currentAuth) {
	return !currentAuth;
}

function getAuthDataForResignup(auth) {
	const nonExternalAuthDatas = Object.values(auth.cache).filter(authData => !authData.externalLoginParamsString);
	return nonExternalAuthDatas && nonExternalAuthDatas.length > 0 ? nonExternalAuthDatas[0] : null;
}

function* authenticateIfNecessary() {
	const state = yield select();
	const {connectivity, auth, customer, fetchProgress} = state;

	const currentAppId = getCurrentAppIdSelector(state);
	const currentServerConfig = getCurrentServerConfig(state);
	const currentAuth = getCurrentAuthSelector(state);

	if (
		connectivity.isOnline !== true ||
		!currentAppId ||
		!currentServerConfig ||
		fetchProgress[LOGIN_ANONYMOUS] ||
		fetchProgress[RESIGNUP] ||
		auth.isDataError
	) {
		return;
	}

	if (isAuthNotFetched(currentAuth)) {
		const dataForResignup = getAuthDataForResignup(auth);

		if (dataForResignup) {
			//TODO Find out what to do when it is not set-restaurant mode
			yield putResolve(resignup(getStartupParams().id, dataForResignup.udid, dataForResignup.secret));
		} else {
			const locale = getCalculatedGlobalShortLocale(customer);

			yield putResolve(loginAnonymous(currentAppId, locale));
		}
	}
}

export const authKeeperSaga = function* authKeeperSaga() {
	yield takeLeading(
		[
			action =>
				![
					LOGIN_ANONYMOUS_REQUEST,
					LOGIN_ANONYMOUS_SUCCESS,
					LOGIN_ANONYMOUS_FAILURE,
					RESIGNUP_REQUEST,
					RESIGNUP_SUCCESS,
					RESIGNUP_FAILURE,
					CUSTOMER_FAILURE,
				].includes(action.type),
		],
		authenticateIfNecessary
	);
};
